var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f4d193bb553406a2892a_icon-earn.svg",
    clipPath: "url(#clip0_13_352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-7",
    d: "M22.5 45.3574C34.9264 45.3574 45 35.2838 45 22.8574C45 10.431 34.9264 0.357422 22.5 0.357422C10.0736 0.357422 0 10.431 0 22.8574C0 35.2838 10.0736 45.3574 22.5 45.3574Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "$",
    d: "M23.9124 33.6678V31.7051C27.3532 31.4386 29.4128 29.379 29.4128 26.4955C29.4128 24.024 27.6924 22.6428 24.8332 22.037L22.4101 21.5282C21.3197 21.3101 20.3263 20.8013 20.3263 19.6867C20.3263 18.4267 21.3682 17.627 22.919 17.627C24.5909 17.627 25.7297 18.6932 25.8266 20.2924H29.1947C28.9766 17.3363 26.8928 15.3493 23.9124 14.9617V12.9263H21.7074V14.9617C18.8724 15.3736 16.9097 17.3363 16.9097 19.9532C16.9097 22.8609 18.9209 23.9755 21.2713 24.5086L23.7428 25.0174C24.9786 25.284 25.8266 25.8897 25.8266 26.9317C25.8266 28.2643 24.5424 29.0155 22.8705 29.0155C20.8593 29.0155 19.7205 27.9493 19.672 26.229H16.304C16.522 29.2093 18.509 31.2447 21.7074 31.6567V33.6678H23.9124Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.357422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEarn);
export default __webpack_public_path__ + "static/media/icon-earn.4d5241d9c972b65efea30e853dd01b12.svg";
export { ForwardRef as ReactComponent };